import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { TableComponent } from '@unilog/ng9-table';
import { GeneralService } from '../services/general.service';


@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {


  // @ViewChild('tableSummary') TableSummary : MatTable;


  isLoading  = false;
  dataLoaded = false;


  dateDeb: string;
  dateFin: string;
  SummarySource ;


  displayedColumns = [
    'Date', 'OF_Num', 'Perso_Matricule', 'nom', 'Machine_Code', 'Realise', 'objectif', 'gain'
  ];


  constructor(
    public http : HttpClient,
    public generalService : GeneralService,
    private datePipe: DatePipe,

  ) {
    datePipe = new DatePipe('en-US');
   }

  ngOnInit(): void {
    
  }

  getFormatedDate(d: Date){
    return this.datePipe.transform(d.toISOString(),'yyyyMMdd');
  }

  refreshData(){ 
    this.isLoading = true;
    var d =new Date(this.dateDeb);
    var f =new Date(this.dateFin);
    var dd= this.getFormatedDate(d)
    var df= this.getFormatedDate(f)
    this.generalService.rechercheTable("API_Rendement&param=ALL," + dd + "," + df ).subscribe((data: any[]) => {
      data.forEach(element => {
        element.Realise = element.Realisé;
      });
      this.SummarySource = data;
      this.isLoading = false;
      this.dataLoaded = true;
    }, err => { this.isLoading = false; });
  }

  exportFile(){

  }

}
